export class EscrowCriteriaApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getEscrowCriteria(params) {
    return this.#http.get('/api/escrow-criteria', { params });
  }

  async createEscrowCriteria(body) {
    return this.#http.post('/api/escrow-criteria', body);
  }

  async editEscrowCriteria({ criteriaId, ...body }) {
    return this.#http.put(`/api/escrow-criteria/${criteriaId}`, body);
  }

  async deleteEscrowCriteria({ criteriaId }) {
    return this.#http.delete(`/api/escrow-criteria/${criteriaId}`);
  }
}
